(function () {
  var sectionObservers = new Map();
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function playVideo(video) {
    var playRequest = video.play();

    if (playRequest && typeof playRequest.catch === 'function') {
      playRequest.catch(function () {
        video.pause();
      });
    }
  }

  function cleanupStories(section) {
    var observer = sectionObservers.get(section);

    if (observer) observer.disconnect();
    section.querySelectorAll('[data-ik-story-video] video').forEach(function (video) {
      video.pause();
    });
    sectionObservers.delete(section);
    delete section.dataset.ikStoriesReady;
  }

  function initializeStories(section) {
    if (!section || section.dataset.ikStoriesReady === 'true') return;

    var videos = Array.prototype.slice.call(section.querySelectorAll('[data-ik-story-video] video'));
    section.dataset.ikStoriesReady = 'true';

    if (!videos.length || reducedMotion.matches) {
      videos.forEach(function (video) {
        video.pause();
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(playVideo);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;

        if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
          playVideo(video);
        } else {
          video.pause();
        }
      });
    }, { threshold: [0, 0.35, 1] });

    videos.forEach(function (video) {
      observer.observe(video);
    });
    sectionObservers.set(section, observer);
  }

  function initializeWithin(root) {
    if (!root) return;
    if (root.matches && root.matches('[data-ik-stories]')) initializeStories(root);
    if (root.querySelectorAll) root.querySelectorAll('[data-ik-stories]').forEach(initializeStories);
  }

  function start() {
    initializeWithin(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.matches && event.target.matches('[data-ik-stories]')
      ? event.target
      : event.target.querySelector && event.target.querySelector('[data-ik-stories]');

    if (section) cleanupStories(section);
  });
})();
